export const HANDLE_COW_SELECTED = "HANDLE_COW_SELECTED";
export const SHOW_COW_EXCREMENT = "SHOW_COW_EXCREMENT";
export const HIDE_COW_EXCREMENT = "HIDE_COW_EXCREMENT";
